import axios from "axios";
import store from "@/store";
import router from "@/router";
import { values } from "lodash";
import baseUrlFactory from "./common.js";

const baseURL = baseUrlFactory();
const secureClient = axios.create({
  baseURL: `${baseURL}/api`,
  withCredentials: true
});

/*
 * Add a response interceptor
 */
secureClient.interceptors.response.use(
  response => {
    return response;
  },
  async function(error) {
    if (error.response && [401, 419].includes(error.response.status)) {
      await store.dispatch("logout");
      router.push({ name: "Login" });
    }
    if (error.response && [422].includes(error.response.status)) {
      store.commit("addNotice", {
        type: "error",
        message: values(error.response.data.errors)[0][0]
      });
    }
    if (error.response && [500].includes(error.response.status)) {
      store.commit("addNotice", {
        type: "error",
        message: error.response.data.message
      });
    }

    return Promise.reject(error);
  }
);

export default secureClient;
